import { Component } from "react";
import { Button } from "./ui/button";

// A render error inside a page (or an overlay it opened) must never blank the whole app: the menu stays, the person gets a way out.
// Keyed by the route in Layout, so moving to another page starts clean.
export default class PageErrorBoundary extends Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    console.error("page render error", error);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="mx-auto mt-12 max-w-md space-y-3 rounded-lg border border-slate-200 bg-white p-6 text-center" role="alert" data-testid="page-error">
        <p className="text-sm font-medium text-slate-900">Cette page n'a pas pu s'afficher.</p>
        <p className="text-sm text-slate-600">Rien n'a été perdu côté serveur. Rechargez la page ; si cela se reproduit, prévenez l'équipe technique.</p>
        <Button type="button" onClick={() => window.location.reload()}>Recharger la page</Button>
      </div>
    );
  }
}
